import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { encryptString,decryptString } from 'src/Utils/encryption';
import { BaseHttpResponse } from 'src/modals/http-request-modals';
import JSEncrypt from 'jsencrypt';
import CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})

export class HttpRequestService {
  response: any;
 


  constructor(private http: HttpClient) { } 
body:any;

Mobile:any;
res:any;

secretkey:any="CGIEAZNXTQ22YAHSA5E38TJZO1ZLMBFH1HR47MAOS0GBENKYY1JOSTVDZKFKOV9WLO2M2KAATFRKREDB3YUEVERVICHXI1QTIGHOMO2A00NBVQAVASHBNNFIG9MGOQRWGX6Y16NZBM6ZLHGVNUIRCCR4ATZPKXQQ6FSQH4JKAUMAMJBNS2AATVQFT3UPA4UBIL8MZXS1"
private public: string = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA7+2X2c4r+ijOSwIcRgzUDjuHLpjR72wJyJd4WEU8HY24s/kISzNr71uDKk1/q+nhR1gFjfUDb0b0TBPqNKCLs0WL/eKKIDXVR6a7dTcup6rpCZtdVFdfJIQKroufzSkxNspxL2pfaLeyvzWrvS5W74rVUlHeKxL6hV0gdwjn4Qx22xaaMTkhQlYdPjlcWZn7jUc/kWGJvdKaptyy1mdALOqQ0kdDmItphVS2/bAxk0b1xabfy8155F85r5pCYfmJFz26J/neBlP9qEGKCJmj1QaM/v0KHI7WvVM6fyrtVOmEfYRRPIi98jzv2Lrhj2IWysyh/BdfLFfN0FAfvrlrnwIDAQAB";


// this methos is used for encrypted data

encryptString(data: string) {
  // Generate random AES key and IV
        const aesKey = CryptoJS.lib.WordArray.random(32); // 256-bit key
        const aesIV = CryptoJS.lib.WordArray.random(16); // 128-bit IV
  
        // Encrypt the payload using AES
        const aesEncrypted = CryptoJS.AES.encrypt(data, aesKey, {
          iv: aesIV,
        });
  
        // Convert AES key to a string format suitable for RSA encryption
        const aesKeyHex = aesKey.toString(CryptoJS.enc.Hex);
  
        // Encrypt the AES key using RSA
        const encrypt = new JSEncrypt();
        encrypt.setPublicKey(this.public);
        const rsaEncryptedKey = encrypt.encrypt(aesKeyHex);
  
  
        if (!rsaEncryptedKey) {
          throw new Error('RSA encryption failed.');
        }
  
        // Base64 encode the IV and encrypted AES payload
        const base64EncodedIV = aesIV.toString(CryptoJS.enc.Base64);
        const base64EncodedData = aesEncrypted.ciphertext.toString(CryptoJS.enc.Base64);
        
        // Creating the payload
        const payload = {
          data: base64EncodedData,
          iv: base64EncodedIV,
          key: rsaEncryptedKey, // RSA-encrypted AES key (already Base64-encoded by jsencrypt)
        };
  
        // Converting to JSON and Base64 encoding the final payload
        const finalPayload = btoa(JSON.stringify(payload));
        return finalPayload;
}


getcampaignInfo(body: any)
{

  // const data = (encryptString(body));  
  const data = this.encryptString(JSON.stringify(body));  
  return this.http.post(environment.baseurl2+ 'Get_Campaign_Details', {data }).pipe(map(response => response))

}

resume_journey(body):Observable<any>{

  const data = this.encryptString(JSON.stringify(body));      
  return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'resume_journey', {data }).pipe(map(response => response)) 
}

  getEventTrack(body:any):Observable<any>{
 
    const data = this.encryptString(JSON.stringify(body));    
    return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'Event_Tracking', {data }).pipe(map(response => response))

  }

  getDeviceTrack(body:any):Observable<any>{

    const data =this.encryptString(JSON.stringify(body));    
    return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'Device_Tracking', {data }).pipe(map(response => response))
  }

 
  sendOTP(body:any) {
    const data = this.encryptString(JSON.stringify(body));   
    return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'Send_OTP_X_Sell', {data }).pipe(map(response => response))
    
  }

  getResendOTP(body:any) {
    const data = this.encryptString(JSON.stringify(body));   
    return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'Send_OTP_X_Sell', {data }).pipe(map(response => response))

  }

getverifyOTP(body){
  const data = this.encryptString(JSON.stringify(body));    
  return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'Verify_OTP_X_Sell', {data }).pipe(map(response => response))
}
getPincodeDetails(body:any) {

  const data = this.encryptString(JSON.stringify(body));  
  return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'pincode', {data }).pipe(map(response =>response)) 

}

  updateaddresinfo(body):Observable<any>{   
     
   const data = this.encryptString(JSON.stringify(body));    
   return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'Lead_Contact_Update', {data }).pipe(map(response =>response)) 



  }

  
  loanconversion(Mobile):Observable<any>{
    return this.http.post<any>(environment.baseurl2 + 'Ready_For_Conversion' , {Mobile});
    
  }
  
  postOfferDecision(body:any):Observable<any>
  {
    const data = this.encryptString(JSON.stringify(body));   
   return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'Offer_Decision', {data}).pipe(map(response =>response       
   )) 

  } 

  callback(body:any):Observable<any>{
    const data = this.encryptString(JSON.stringify(body));   
    return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'Check_Callback_Status', {data }).pipe(map(response =>response)) 
  }
  
  afterlds(body):Observable<any>{
     const data = this.encryptString(JSON.stringify(body));  
    return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'APP_Install', {data }).pipe(map(response =>response
    )) 
  }

  getKYCurl(body):Observable<any>{
    const data = this.encryptString(JSON.stringify(body));   
    return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'Satellite_Services', {data }).pipe(map(response =>response)) 


  }
  
  directlds(body : any):Observable<any>{

    const data = this.encryptString(JSON.stringify(body));   
    return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'LDS_Accept', {data }).pipe(map(response => response)) 

  }
  kyc_callback(body):Observable<any>{
    
      const data = this.encryptString(JSON.stringify(body));   
      return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'Get_EKYC_Callback', {data }).pipe(map(response => response)) 

    }
    take_selfie(body: any):Observable<any>{
    
      const data =this.encryptString(JSON.stringify(body));  
      return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'Take_Selfie', {data }).pipe(map(response => response)) 

    }
   

    getkycaddress(body:any):Observable<any>{

      const data = this.encryptString(JSON.stringify(body));
      return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'Get_Mailing_Address', {data }).pipe(map(response => response)) 
    }
    exisiting_nach(body:any):Observable<any>{
      const data = this.encryptString(JSON.stringify(body));  
      return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'Nach_Create', {data }).pipe(map(response => response)) 


    }
    nachdata(body:any):Observable<any>{
      const data = this.encryptString(JSON.stringify(body));   
      return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'Get_Old_Nach_data', {data }).pipe(map(response => response)) 
      
    }
  getAccountAggURL(accountDetails):Observable<any>{
    const headers = new HttpHeaders({'Content-Type':'application/json', 'authorization': 'LPFBTU8LSXSIIHMLFC9YTHHW1KYFKI'});
    return this.http.post<any>('https://dmi-aa.vistaconnect.com/Generate_Request_Key' , accountDetails , {headers}).pipe(map(response=>response.data));
  }

  ldsAccepted(body:any):Observable<any>{    
    
    const data = this.encryptString(JSON.stringify(body)); 
    return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'LDS_Accept', {data }).pipe(map(response => response)) 

  }

  utmservice(body:any):Observable<any>{

    const data = this.encryptString(JSON.stringify(body));    
    return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'abnd_utm', {data }).pipe(map(response =>response)) 



  }



getExistingLoan(body:any):Observable<any>{    
    
    const data = this.encryptString(JSON.stringify(body)); 
    return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'Get_Existing_Loan_Details', {data }).pipe(map(response =>response)) 
  }

trackevent_webengage(body)
{
  // const headers = new HttpHeaders({ 'Authorization': '93ca3bb4-e1c9-40ab-a356-878a84b20764'});
  const headers = new HttpHeaders().set('Authorization', `${'93ca3bb4-e1c9-40ab-a356-878a84b20764'}`)
  return this.http.post('https://api.in.webengage.com/v1/accounts/in~~71680b3d/events',body,{headers})
 

}

// Insurance 
setInsurance(body:any):Observable<any>{    
    
  const data = this.encryptString(JSON.stringify(body));   
  return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'insurance_loan', {data }).pipe(map(response =>response)) 
}
insurancedoc(body:any){    
    
  const data = this.encryptString(JSON.stringify(body));    
  return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'Insurance_Details', {data }).pipe(map(response =>response)) 
}

applypromocode(body: any){
  const data = this.encryptString(JSON.stringify(body));
  return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'coupon_Code_Applied', {data }).pipe(map(response => response)) 
}

submitpromocode(body: any){
  const data =  this.encryptString(JSON.stringify(body));
  return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'customer_submit_coupon_code', {data }).pipe(map(response => response))
}




// KFS Esign


sendKFSOTP(body:any) {
  const data =  this.encryptString(JSON.stringify(body));   
  return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'kfs_OTP_Generation', {data }).pipe(map(response => response))
  
}
verifyKFSOTP(body){
  const data =  this.encryptString(JSON.stringify(body));   
  return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'kfs_OTP_Authentication', {data }).pipe(map(response => response))
}


//  Topup Pf update

update_PF(body){
  const data =  this.encryptString(JSON.stringify(body));   
  return this.http.post<BaseHttpResponse>(environment.baseurl2+ 'Top_Up_Processing_Fess_Update', {data }).pipe(map(response => response))
}

}